import { Card, Col, Input, Row, Spin, Skeleton, Statistic } from "antd";
import React, { useEffect, useState } from "react";

import {
  ShoppingOutlined, // For Total Orders
  DollarOutlined, // For Gross Sale
  BankOutlined, // For Net Sale
  FileTextOutlined, // For Total Taxes
  PercentageOutlined, // For Total Discount
  CarOutlined, // For Delivery Amounts
  WalletOutlined, // For Cash Sale
  CreditCardOutlined, // For Card Sale
} from "@ant-design/icons";

import { useDispatch, useSelector } from "react-redux";
import StatisticCard from "../../components/NewComponents/StatisticCard.jsx";
import DonutChart from "../../components/NewComponents/DonutChart.jsx";
import {
  delay,
  formatCurrencyValue,
  nFormatter,
} from "../../functions/generalFunctions";
import {
  changeCompany,
  changeDateFrom,
  changeDateTo,
  changeBranch,
} from "../../redux/actions/authAction";
import SideMenu from "./SideMenu";
import "./style.css";
// import { TbShoppingCartDiscount } from "react-icons/ci";
import { FunnelPlotOutlined, LoadingOutlined } from "@ant-design/icons";
import { COMPANY_ADMIN } from "../../common/SetupMasterEnum";
import { INPUT_SIZE } from "../../common/ThemeConstants";
import FormButton from "../../components/general/FormButton";
import FormSelect from "../../components/general/FormSelect";
import { getDate } from "../../functions/dateFunctions";
import { getAllDataFromIDB } from "../../functions/storage/getDataFromIDB";
import updateDataToIDB from "../../functions/storage/updateDataToIDB";
import { postRequest } from "../../services/mainApp.service";
import TopProductsTable from "../../components/NewComponents/TopProductsTable.jsx";

import AreaChart from "../../components/NewComponents/AreaChart.jsx";
const Dashboard = () => {
  const dispatch = useDispatch();

  const [dashboardData, setDashboardData] = useState([]);
  const [reportData, setReportData] = useState({});
  const [paymentMode, setPaymentMode] = useState([]);
  const [productlist, setProductList] = useState([]);
  const [orderMode, setOrderMode] = useState([]);
  const [orderSource, setOrderSource] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [companySaleList, setCompanySaleList] = useState([]);
  const [branchDropdownList, setBranchDropdownList] = useState([]);

  const [loading, setLoading] = useState(false);
  const appStore = useSelector((state) => state.authReducer);
  const isDashboard = appStore.menuList.some((item) => item.Menu_URL == "#");

  const {
    companyList,
    RoleName,
    CompanyId,
    RoleId,
    dateFrom,
    dateTo,
    branchId,
  } = useSelector((state) => state.authReducer);
  const [data, setData] = useState({
    DateFrom: getDate(Date.now() - 30 * 24 * 60 * 60 * 1000), // Last 30 days,
    DateTo: getDate(),
    BranchId: null,
  });

  const { RefreshStats } = useSelector((state) => state.RefreshReducer);

  const handleCompanyChange = (companyId) => {
    if (companyId !== null) {
      let data = companyList.filter(
        (listItem) => listItem.CompanyId === companyId
      );
      getAllDataFromIDB("userData", (result) => {
        updateDataToIDB(
          "userData",
          result[0].id,
          {
            ...result[0],
            CompanyId: data[0].CompanyId,
            CompanyName: data[0].CompanyName,
          },
          () => {
            dispatch(changeCompany(data[0]));
          }
        );
      });

      dispatch(changeBranch(null));
    } else if (companyId === null) {
      getAllDataFromIDB("userData", (result) => {
        updateDataToIDB(
          "userData",
          result[0].id,
          {
            ...result[0],
            CompanyId: null,
            CompanyName: null,
          },
          () => {
            dispatch(changeCompany({}));
          }
        );
      });
    }
  };

  const chartsConfig = [
    {
      title: "Order By Status",
      data: dashboardData?.Table1,
      dataKey: "OrderCount",
      nameKey: "OrderStatus",
      isOrderStatus: true,
    },

    {
      title: "New vs Returning Customers",
      data: dashboardData?.Table6,
      dataKey: "OrderCount",
      nameKey: "CustomerType",
    },
    {
      title: "Payment Type",
      data: dashboardData?.Table8,
      dataKey: "OrderCount",
      nameKey: "PaymentMode",
    },
    {
      title: "Order By Source",
      data: dashboardData?.Table3,
      dataKey: "OrderCount",
      nameKey: "OrderSource",
    },
    {
      title: "Order By Gender",
      data: dashboardData?.Table7,
      dataKey: "OrderCount",
      nameKey: "Title",
    },
  ];

  const productsColumns = [
    // {
    //   title: 'Category Name',
    //   dataIndex: 'CategoryName',
    //   key: 'CategoryName',
    //   render: (text) => <strong>{text}</strong>,
    // },
    {
      title: "Product",
      dataIndex: "Product",
      key: "Product",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Times Sold",
      dataIndex: "Quantity",
      key: "Quantity",
      align: "right",
      // sorter: (a, b) => a.Quantity - b.Quantity,
      render: (quantity) => <span>{quantity}</span>,
    },
    {
      title: "Sales Amount",
      dataIndex: "SalesAmount",
      key: "SalesAmount",
      align: "right",
      // sorter: (a, b) => a.SalesAmount - b.SalesAmount,
      render: (amount) => <span>Rs. {amount.toLocaleString("en-PK")}</span>,
    },
    // {
    //   title: 'Percentage',
    //   dataIndex: 'Percentage',
    //   key: 'Percentage',
    //   // sorter: (a, b) => a.Percentage - b.Percentage,
    //   render: (percentage) => (
    //     <span>
    //       {percentage.toFixed(1)}%
    //     </span>
    //   ),
    // },
  ];

  const categoriesColumns = [
    {
      title: "Category Name",
      dataIndex: "CategoryName",
      key: "CategoryName",
      render: (text) => <strong>{text}</strong>,
    },
    // {
    //   title: 'Times Sold',
    //   dataIndex: 'Quantity',
    //   key: 'Quantity',
    //   align: 'right',
    //   // sorter: (a, b) => a.Quantity - b.Quantity,
    //   render: (quantity) => <span>{quantity}</span>,
    // },
    {
      title: "Sales Amount",
      dataIndex: "SalesAmount",
      key: "SalesAmount",
      align: "right",
      // sorter: (a, b) => a.SalesAmount - b.SalesAmount,
      render: (amount) => <span>Rs. {amount.toLocaleString("en-PK")}</span>,
    },
    {
      title: "Percentage",
      dataIndex: "Percentage",
      key: "Percentage",
      align: "right",
      // sorter: (a, b) => a.Percentage - b.Percentage,
      render: (percentage) => <span>{percentage.toFixed(2)}%</span>,
    },
  ];

  const customerColumns = [
    {
      title: "Customer Name",
      dataIndex: "CustomerName",
      key: "CustomerName",
      render: (text) => <strong>{text}</strong>, // Bold for emphasis
    },
    {
      title: "Phone Number",
      dataIndex: "PhoneNumber",
      key: "PhoneNumber",
      render: (text) => <span>{text}</span>, // Blue for visual pop
    },
    {
      title: "No of Orders",
      dataIndex: "OrderCount",
      key: "OrderCount",
      align: "right", // Align numbers to the right
      render: (count) => (
        <span>{count}</span> // Bold and green for numbers
      ),
    },
    {
      title: "Net Sales",
      dataIndex: "NetSales",
      key: "NetSales",
      align: "right", // Align numbers to the right
      render: (amount) => (
        <span>Rs. {amount.toLocaleString("en-PK")}</span> // Bold and red-orange for emphasis
      ),
    },
  ];

  const getReport = () => {
    setLoading(true);
    postRequest("DashboardReport", {
      OperationId: 1,
      CompanyId: appStore.CompanyId,
      BranchId:
        appStore.userBranchList?.length > 0 &&
          appStore.IsPos === true &&
          appStore.RoleId !== COMPANY_ADMIN
          ? appStore.userBranchList[0]?.BranchId
          : RoleId === 14
            ? branchId
            : data.BranchId,
      DateFrom: RoleId === 14 ? dateFrom : data.DateFrom,
      DateTo: RoleId === 14 ? dateTo : data.DateTo,
    })
      .then((res) => {
        setLoading(false);
        setDashboardData(res?.data?.DataSet);
        setReportData(res.data.DataSet.Table[0]);
        setOrderMode(res.data.DataSet.Table1);
        setOrderSource(res.data.DataSet.Table2);
        setPaymentMode(res.data.DataSet.Table3);
        setProductList(res.data.DataSet.Table4);
        setBranchList(res.data.DataSet.Table5);
        setCompanySaleList(res.data.DataSet.Table6);

        setBranchDropdownList(res.data.DataSet.Table7);

        if (res.data.DataSet.Table11) {
          setBranchDropdownList(res.data.DataSet.Table11);
        }

        // setChartData(res.data.DataSet.Table1);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  useEffect(() => {

    getReport();
  }, []);

  useEffect(() => {

    if (RefreshStats == 1) {
      getReport();

      dispatch({ type: "REFRESH_STATS", payload: 0 });
    }
  }, [RefreshStats]);

  // console.log("checking dashboard data", dashboardData);

  return (
    <div style={{ display: "flex", height: "100%", width: "100%" }}>
      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
        {isDashboard && (
          <>
            <div className="mt-5">
              {/* <h2>Dashboardd</h2> */}
              <div className="flex gap-2" gutter={[10, 10]}>
                <Col
                  className="dashboardChartFilterInput"
                  {...(RoleId === 14 && { span: 4 })}
                >
                  <span>Date From</span>
                  <Input
                    type="date"
                    style={{ width: "100%" }}
                    value={RoleId === 14 ? dateFrom : data.DateFrom}
                    onChange={(e) => {
                      RoleId === 14
                        ? dispatch(changeDateFrom(e.target.value))
                        : setData({ ...data, DateFrom: e.target.value });
                    }}
                  />
                </Col>
                <Col
                  className="dashboardChartFilterInput"
                  {...(RoleId === 14 && { span: 4 })}
                >
                  <span>Date To</span>
                  <Input
                    type="date"
                    style={{ width: "100%" }}
                    value={RoleId === 14 ? dateTo : data.DateTo}
                    onChange={(e) => {
                      RoleId === 14
                        ? dispatch(changeDateTo(e.target.value))
                        : setData({ ...data, DateTo: e.target.value });
                    }}
                  />
                </Col>

                {RoleName === "Management" && RoleId === 14 && (
                  <FormSelect
                    value={CompanyId}
                    onChange={(e) => {
                      handleCompanyChange(e.value);
                    }}
                    label="Select Company"
                    {...(RoleId === 14 && { colSpan: 5 })}
                    listItem={companyList}
                    idName="CompanyId"
                    valueName="CompanyName"
                    placeholder="Choose a Company"
                  />
                )}
                <FormSelect
                  listItem={
                    RoleId === 14
                      ? branchDropdownList.filter(
                        (company) => company.CompanyId === CompanyId
                      )
                      : appStore.userBranchList || []
                  }
                  {...(RoleId === 14 && { colSpan: 6 })}
                  idName="BranchId"
                  valueName="BranchName"
                  size={INPUT_SIZE}
                  className="textInput w-60"
                  label="Select Branch"
                  value={RoleId === 14 ? branchId : data.BranchId}
                  onChange={(e) => {
                    RoleId === 14
                      ? dispatch(changeBranch(e.value))
                      : setData({ ...data, BranchId: e.value });
                  }}
                />
                <div className="flex items-end">
                  <FormButton
                    title={RoleId === 14 ? "" : "Apply"}
                    icon={<FunnelPlotOutlined />}
                    sm={6}
                    type="primary"
                    onClick={getReport}
                  />
                </div>
              </div>
              <div className="mt-7 grid grid-cols-1 gap-3 md:sgrid-cols-2 lg:grid-cols-3 xl:grid-cols-4 w-full">
                <>
                  <StatisticCard
                    title="Total Orders"
                    value={
                      RoleId === 14
                        ? formatCurrencyValue(reportData?.TotalOrders_Landed)
                        : nFormatter(reportData?.TotalOrders_Landed, 1)
                    }
                    statIcon={ShoppingOutlined}
                    loading={loading}
                    className="bg-blue-600 p-3 rounded-full text-white "
                  />
                </>
                <>
                  <StatisticCard
                    // title={`Gross Sale ${
                    //   RoleId === 14 ? "(PKR)" : "(Rs)"
                    // } Without Tax`}
                    title="Gross Sale"
                    value={
                      // RoleId === 14
                      //   ? formatCurrencyValue(reportData?.Gross)
                      //   : nFormatter(parseFloat(reportData?.Gross), 1)
                      parseFloat(reportData?.Gross) || 0
                    }
                    statIcon={DollarOutlined}
                    className="bg-blue-600 p-3 rounded-full text-white "
                    loading={loading}
                  />
                </>

                <>
                  <StatisticCard
                    // title={`Net Sale ${
                    //   RoleId === 14 ? "(PKR)" : "(Rs)"
                    // } Without Tax`}
                    title="Net Sale"
                    value={
                      // RoleId === 14
                      //   ? formatCurrencyValue(reportData?.NetSale)
                      //   : nFormatter(parseFloat(reportData?.NetSale), 1)
                      parseFloat(reportData?.NetSale) || 0
                    }
                    statIcon={BankOutlined}
                    className="bg-yellow-500 p-3 rounded-full text-white"
                    loading={loading}
                  />
                </>

                <>
                  <StatisticCard
                    title={`Total Taxes ${RoleId === 14 ? "(PKR)" : "(Rs)"}`}
                    value={
                      // RoleId === 14
                      //   ? formatCurrencyValue(reportData?.Tax)
                      //   : nFormatter(parseFloat(reportData?.Tax), 1)
                      parseFloat(reportData?.Tax) || 0
                    }
                    statIcon={FileTextOutlined}
                    className="bg-red-500 p-3 rounded-full text-white "
                    loading={loading}
                  />
                </>

                <>
                  <div>
                    <StatisticCard
                      title={`Total Discount ${RoleId === 14 ? "(PKR)" : "(Rs)"
                        }`}
                      value={
                        // RoleId === 14
                        //   ? formatCurrencyValue(reportData?.Discount)
                        //   : nFormatter(parseFloat(reportData?.Discount), 1)
                        parseFloat(reportData?.Discount) || 0
                      }
                      statIcon={PercentageOutlined}
                      className="bg-purple-500 p-3 rounded-full text-white "
                      loading={loading}
                    />
                  </div>
                </>
                <div>
                  <StatisticCard
                    title={`Delivery Charges ${RoleId === 14 ? "(PKR)" : "(Rs)"
                      }`}
                    value={
                      // RoleId === 14
                      //   ? formatCurrencyValue(reportData?.DeliveryCharges)
                      //   : nFormatter(
                      //       parseFloat(reportData?.DeliveryCharges),
                      //       1
                      //     )
                      parseFloat(reportData?.DeliveryCharges) || 0
                    }
                    statIcon={CarOutlined}
                    className="bg-orange-500 p-3 rounded-full text-white "
                    loading={loading}
                  />
                </div>
                <>
                  <div>
                    <StatisticCard
                      title={`Cash Sale ${RoleId === 14 ? "(PKR)" : "(Rs)"}`}
                      value={
                        // RoleId === 14
                        //   ? formatCurrencyValue(reportData?.Cash)
                        //   : nFormatter(parseFloat(reportData?.Cash), 1)
                        // parseFloat(reportData?.Cash)
                        0
                      }
                      statIcon={WalletOutlined}
                      className="bg-teal-500 p-3 rounded-full text-white "
                      loading={loading}
                    />
                  </div>
                </>
                <>
                  <div>
                    <StatisticCard
                      title={`Card Sale ${RoleId === 14 ? "(PKR)" : "(Rs)"}`}
                      value={
                        // RoleId === 14
                        //   ? formatCurrencyValue(reportData?.Cash)
                        //   : nFormatter(parseFloat(reportData?.Cash), 1)
                        // parseFloat(reportData?.Card)
                        0
                      }
                      statIcon={CreditCardOutlined}
                      className="bg-teal-500 p-3 rounded-full text-white "
                      loading={loading}
                    />
                  </div>
                </>
              </div>
            </div>
          </>
        )}

        <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-3">
          {chartsConfig.map((chart, index) => (
            <div key={index} className="bg-white  rounded-xl  ">
              <p className="text-2xl font-bold mt-5 pt-3 pl-3">{chart.title}</p>
              <DonutChart
                data={chart.data}
                loading={loading}
                dataKey={chart.dataKey}
                nameKey={chart.nameKey}
                isOrderStatus={chart.isOrderStatus} // Optional props
              />
            </div>
          ))}
          <TopProductsTable
            data={dashboardData?.Table2}
            columns={productsColumns}
            title="Most Sold Products"
            showTopCount={5}
          />
        </div>

        <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-3">
          <TopProductsTable
            data={dashboardData?.Table9}
            columns={categoriesColumns}
            title="Top Categories"
            showTopCount={5}
          />
          <TopProductsTable
            data={dashboardData?.Table10}
            columns={customerColumns}
            title="Most Valuable Customers"
            showTopCount={5}
          />
        </div>

        <div className="bg-white border rounded-xl mt-3 ">
          <div className="px-2 pt-3 pb-2 text-center">
            <h2 className="text-2xl font-bold mb-1">Orders By Area</h2>
          </div>
          <AreaChart data={dashboardData?.Table4} />
        </div>

        {/* {RoleId === 14 && (
          <div id="1" className="dashboardTableInner" style={{}}>
            <div style={{ width: "inherit" }}>
              <Row className="dashboardTableRow" gutter={[10, 10]}>
                {orderMode?.length > 0 && (
                  <Col
                    xs={24}
                    sm={12}
                    md={12}
                    xl={12}
                    style={{ padding: 0 }}
                    className="tableColumn"
                  >
                    <div
                      className="dashboardtableStyle"
                      style={{
                        background: "#ffffff",
                        boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
                        borderRadius: "4px",
                        padding: "18px",
                        marginRight: "10px",
                        height: "37vh",
                        width: "70vh",
                        borderTop: "10px",
                      }}
                    >
                      <h2>Sales by Order Mode</h2>
                      <div className="dashboardTableHeight">
                        <table style={{}}>
                          <tr>
                            <td>Order Mode</td>
                            <td>Count</td>
                            <td>Amount</td>
                          </tr>
                          {orderMode.map((item, _index) => (
                            <tr>
                              <td>{item.OrderMode}</td>
                              <td>{item.OrderCount || 0}</td>
                              <td>
                                {loading ? (
                                  <Spin indicator={antIcon} />
                                ) : (
                                  <h2>
                                    {RoleId === 14
                                      ? formatCurrencyValue(item.TotalAmount)
                                      : nFormatter(
                                          parseFloat(item.TotalAmount),
                                          1
                                        )}
                                  </h2>
                                )}
                              </td>
                            </tr>
                          ))}
                        </table>
                      </div>
                    </div>
                  </Col>
                )}

                {companySaleList?.length > 0 && (
                  <Col
                    xs={24}
                    sm={12}
                    md={12}
                    xl={12}
                    style={{ padding: 0, display: "table" }}
                    className="tableColumn"
                  >
                    <div
                      style={{
                        background: "#ffffff",
                        boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
                        borderRadius: "4px",
                        padding: "18px",
                        marginRight: "10px",
                        height: "37vh",
                        width: "70vh",
                        borderTop: "10px",
                      }}
                    >
                      <h2>Sales By Company</h2>
                      <div className="dashboardTableHeight">
                        <table>
                          <tr>
                            <td>Company</td>
                            <td>Branch</td>
                            <td>Total Orders</td>
                            <td>Net Sale</td>
                          </tr>
                          {companySaleList.map((item, _index) =>
                            loading ? (
                              <tr>
                                <td colspan="3">
                                  <Spin indicator={antIcon} />
                                </td>
                              </tr>
                            ) : (
                              <tr>
                                <td>{item.CompanyName}</td>
                                <td>{item.BranchName}</td>
                                <td>{item.TotalOrders}</td>
                                <td>
                                  {loading ? (
                                    <Spin indicator={antIcon} />
                                  ) : (
                                    <h2>
                                      {RoleId === 14
                                        ? formatCurrencyValue(item.NetSale)
                                        : nFormatter(
                                            parseFloat(item.NetSale),
                                            1
                                          )}
                                    </h2>
                                  )}
                                </td>
                              </tr>
                            )
                          )}
                        </table>
                      </div>
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </div>
        )}

        {RoleId !== 14 && (
          <div id="1" className="dashboardTableInner" style={{}}>
            <div style={{ width: "inherit" }}>
              <Row className="dashboardTableRow" gutter={[10, 10]}>
                {orderMode?.length > 0 && (
                  <Col
                    xs={24}
                    sm={12}
                    md={12}
                    xl={12}
                    style={{ padding: 0 }}
                    className="tableColumn"
                  >
                    <div className="dashboardtableStyle">
                      <h2>Sales by Order Mode</h2>
                      <div className="dashboardTableHeight">
                        <table style={{}}>
                          <tr>
                            <td>Order Mode</td>
                            <td>Count</td>
                            <td>Amount</td>
                          </tr>
                          {orderMode.map((item, _index) => (
                            <tr>
                              <td></td>
                              <td>{item.OrderMode}</td>
                              <td>{item.OrderCount || 0}</td>
                              <td>
                                {loading ? (
                                  <Spin indicator={antIcon} />
                                ) : (
                                  <h2>
                                    {RoleId === 14
                                      ? formatCurrencyValue(item.TotalAmount)
                                      : nFormatter(
                                          parseFloat(item.TotalAmount),
                                          1
                                        )}
                                  </h2>
                                )}
                              </td>
                            </tr>
                          ))}
                        </table>
                      </div>
                    </div>
                  </Col>
                )}

                {orderSource?.length > 0 && (
                  <Col
                    xs={24}
                    sm={12}
                    md={12}
                    xl={12}
                    style={{ padding: 0 }}
                    className="tableColumn"
                  >
                    <div className="dashboardtableStyle">
                      <h2>Sales by Order Source</h2>
                      <div className="dashboardTableHeight">
                        <table>
                          <tr>
                            <td>Order Source</td>
                            <td>Count</td>
                            <td>Amount</td>
                          </tr>
                          {orderSource.map((item, _index) => (
                            <tr>
                              <td>{item.OrderSource}</td>
                              <td>{item.OrderCount || 0}</td>
                              <td>
                                {loading ? (
                                  <Spin indicator={antIcon} />
                                ) : (
                                  <h2>
                                    {RoleId === 14
                                      ? formatCurrencyValue(item.TotalAmount)
                                      : nFormatter(
                                          parseFloat(item.TotalAmount),
                                          1
                                        )}
                                  </h2>
                                )}
                              </td>
                            </tr>
                          ))}
                        </table>
                      </div>
                    </div>
                  </Col>
                )}
                {paymentMode?.length > 0 && (
                  <Col
                    xs={24}
                    sm={12}
                    md={12}
                    xl={12}
                    style={{ padding: 0 }}
                    className="tableColumn"
                  >
                    <div className="dashboardtableStyle">
                      <h2>Third Party Sales</h2>
                      <div className="dashboardTableHeight">
                        <table>
                          <tr>
                            <td>Payment Mode</td>
                            <td>Count</td>
                            <td>Amount</td>
                          </tr>
                          {paymentMode.map((item, _index) => (
                            <tr>
                              <td>{item.PaymentMode}</td>
                              <td>{item.OrderCount || 0}</td>
                              <td>
                                {loading ? (
                                  <Spin indicator={antIcon} />
                                ) : (
                                  <h2>
                                    {RoleId === 14
                                      ? formatCurrencyValue(item.TotalAmount)
                                      : nFormatter(
                                          parseFloat(item.TotalAmount),
                                          1
                                        )}
                                  </h2>
                                )}
                              </td>
                            </tr>
                          ))}
                        </table>
                      </div>
                    </div>
                  </Col>
                )}
                {productlist?.length > 0 && (
                  <Col
                    xs={24}
                    sm={12}
                    md={12}
                    xl={12}
                    style={{ padding: 0 }}
                    className="tableColumn"
                  >
                    <div className="dashboardtableStyle">
                      <h2>Product Sales</h2>
                      <div className="dashboardTableHeight">
                        <table>
                          <tr>
                            <td>Branch</td>
                            <td>Product</td>
                            <td>Quantity</td>
                            <td>Amount</td>
                          </tr>
                          {productlist.map((item, _index) =>
                            loading ? (
                              <tr>
                                <td colspan="3">
                                  <Spin indicator={antIcon} />
                                </td>
                              </tr>
                            ) : (
                              <tr>
                                <td>{item.BranchName}</td>
                                <td>{item.Product}</td>
                                <td>{item.Quantity}</td>
                                <td>
                                  <h2>
                                    {RoleId === 14
                                      ? formatCurrencyValue(
                                          item.PriceWithoutGST
                                        )
                                      : nFormatter(
                                          parseFloat(item.PriceWithoutGST),
                                          1
                                        )}
                                  </h2>
                                </td>
                              </tr>
                            )
                          )}
                        </table>
                      </div>
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </div>
        )}
        {RoleId !== 14 && branchList?.length > 0 && (
          <Col
            xs={24}
            sm={12}
            md={12}
            xl={12}
            style={{ padding: 0, display: "table" }}
            className="tableColumn"
          >
            <div
              style={{
                background: "#ffffff",
                boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
                borderRadius: "4px",
                padding: "18px",
                marginRight: "10px",
                height: "37vh",
                width: "70vh",
                borderTop: "10px",
                marginTop: "37px",
              }}
            >
              <h2>Inventory Transaction Status</h2>
              <div className="dashboardTableHeight">
                <table>
                  <tr>
                    <td>Branch </td>
                    <td>GRN</td>
                    <td>Receiving</td>
                    <td>Transfer</td>
                    <td>Closing </td>
                  </tr>
                  {branchList.map((item, _index) =>
                    loading ? (
                      <tr>
                        <td colspan="3">
                          <Spin indicator={antIcon} />
                        </td>
                      </tr>
                    ) : (
                      <tr>
                        <td>{item.BranchName}</td>
                        <td>{item.GRN}</td>
                        <td>{item.Receiving}</td>
                        <td>{item.Transfer}</td>
                        <td>{item.Closing}</td>
                      </tr>
                    )
                  )}
                </table>
              </div>
            </div>
          </Col>
        )}

        <SideMenu />
        <div>
          <div style={{ width: "50vw" }}></div>
        </div> */}
      </div>
    </div>
  );
};

export default Dashboard;
